// Builds a default issue description from a fault, e.g.
// "<reason or fault_key> - <component_description, device_name, or description>"
// Shared by AddNewIssue.js, IssueSummary.js, and IncidentMgmt.js so the three
// entry points into issue creation stay in sync.
export const buildFaultDescription = (fault) => {
  let desc = ''
  if (fault.reason) {
    desc += fault.reason
  } else if (fault.fault_key) {
    desc += fault.fault_key
  }
  if (fault.component_description) {
    desc += ' - ' + fault.component_description
  } else if (fault.device_name) {
    desc += ' - ' + fault.device_name
  } else if (fault.description) {
    desc += ' - ' + fault.description
  }
  return desc
}
